import React from 'react';

import {
  List,
  Datagrid, 
  TextField, 
  Edit,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
  DeleteButton,
  FileInput,
  FileField,
  useRecordContext,
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import ToggleRowStyle from './Common';
import { useParams } from 'react-router-dom';

const LoerieleersentrumEdit = (props) => {
  const { id } = useParams();
  
  const grades = [
    {id: 1, name: 'Grade 1'},
    {id: 2, name: 'Grade 2'},
    {id: 3, name: 'Grade 3'},
    {id: 4, name: 'Grade 4'},
    {id: 5, name: 'Grade 5'},
    {id: 6, name: 'Grade 6'},
    {id: 7, name: 'Grade 7'},
  ];
  
  const MyTextField = () => {
    const record = useRecordContext();
    if (!record) return null;
    return <span>{record.file.split("$:$")[1] ?? record.file}</span>
  }
  
  return (
    <>
      <Edit {...props} title="Edit remedial content">
        <SimpleForm>
          <SelectInput source="grade" choices={grades} />
          <ReferenceInput 
            label="Subject" 
            source="subject_id" 
            reference="subjects"
            filter={{ remedial: true }}
          >
            <SelectInput />
          </ReferenceInput>
          <TextInput source="title" />
          <RichTextInput source="description" />
          <FileInput 
            label="New attachments" 
            source="attachments" 
            multiple={true} 
            sx={{ 
              boxShadow: '0px 0px 6px 4px darkgrey', 
              padding: '0px 8px', 
              '& span': { fontSize: '1.75em', color: 'darkred'}
            }}
          >
            <FileField source="src" title="title" />
          </FileInput>       
        </SimpleForm>
      </Edit>
      <h2 style={{ backgroundColor: '#cdcdcd', paddingLeft: '8px'}}>Current attachments</h2>
      <SimpleForm toolbar={false}>
        <List {...props}
          actions={false}
          resource="lesson_items"     
          title=" "
          filter={{ lesson_id: id }}
          sort={{ field: 'id', order: 'ASC' }}
          sx={{ 
            display: 'flex', 
            flexDirection: 'row', 
            minWidth: '100%',
            '& .RaDatagrid-table tr td:last-child': {
              maxWidth: '10%',
              width: '10%',
            },
          }}
        >
          <Datagrid 
            key={record => `${record.id}`} 
            rowStyle={ToggleRowStyle} 
            bulkActionButtons={false}
          >
            <MyTextField source='file' />
            <DeleteButton mutationMode="pessimistic" redirect={`/loerieleersentrum/${id}`} />                       
          </Datagrid>
        </List>
      </SimpleForm>
    </>
  );
}

export default LoerieleersentrumEdit;
